import { locator } from "../helpers/common";
import { IScale, Locator, PointData, ScaleType } from "../types";
import BaseSeria from "./BaseSeria";

export default class ScaleSeria extends BaseSeria {
	protected _yLocator: Locator;
	protected _xLocator: Locator;
	protected xScale: IScale;
	protected yScale: IScale;
	protected _gradient;

	addScale(type: ScaleType, scale: IScale): void {
		if (type === "bottom" || type === "top") {
			this.xScale = scale;
			this._xLocator = scale.locator;
		} else {
			this.yScale = scale;
			this._yLocator = locator(this.config.value);
		}
	}

	paint(width: number, height: number) {
		super.paint(width, height);
	}

	dataReady(prev?: PointData[]) {
		if (!this.config.active) {
			return (this._points = []);
		}

		this._points = this._data.map((item, index) => {
			// raw values
			const x = this._xLocator(item);
			const y = this._yLocator(item);

			const set = [x, y, item.id, x, y];
			if (prev) {
				set[1] += prev[index][1];
			}
			return set;
		});

		return this._points;
	}

	protected _calckFinalPoints(width: number, height: number) {
		this._points.forEach((item, index) => {
			// scaled values
			item[0] = this.xScale.point(item[0]) * width || 0;
			const pointHeight = this.yScale.point(item[1]) * height;
			item[1] = !isNaN(pointHeight) ? pointHeight : this.config.type === "xbar" ? 0 : height;
		});
	}

	protected _defaultLocator(v) {
		return [this._yLocator(v), this._xLocator(v)];
	}
}
